var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"user-tab-security"},[_c('file-table',{attrs:{"loading":false,"files":_vm.localFiles,"groups-disabled":"","handle-document-generation":false,"disable-upload":"","disable-delete":"","disable-update":""}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }